module.exports = __webpack_public_path__ + "static/Erkado-fdd755820ddecd1ca628fec38419b592.png";